import React from 'react';

import GCMSSVG from '../svg/icons/graphcms.svg';
import Link from '../components/renderers/Link';

const Page404 = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-between max-w-4xl mx-auto px-6 py-32 text-center">
      <GCMSSVG className="mb-6 text-cornflower w-20" />
      <h1 className="font-bold text-6xl tracking-tighter">404</h1>
      <h4 className="font-medium text-xl">Page Not Found</h4>
      <p className="my-4">
        We couldn't find the page you were looking for. Perhaps it doesn't
        exist?
      </p>
      <ul className="-mx-2 flex">
        <li className="px-2">
          <Link href="/">Home</Link>
        </li>
        <li className="px-2">
          <Link href="/contact">Contact</Link>
        </li>
        <li className="px-2">
          <Link href="/docs">Docs</Link>
        </li>
      </ul>
    </div>
  );
};

export default Page404;
